import React from "react";
import { CheckCircleFill } from "react-bootstrap-icons";

const features = [
  "Certified Implementation Specialists",
  "Industry-Specific Solution Design",
  "Comprehensive Training Programs",
  "Dedicated Account Management",
  "Reusable Best Practices & Templates",
];

const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "200+", label: "Projects Delivered" },
  { value: "50+", label: "Enterprise Clients" },
  { value: "99%", label: "Satisfaction Rate" },
];

export default function WhatSetsUsApart() {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row align-items-center align-items-centerone g-4">
          {/* Left Column */}
          <div className="col-lg-6">
            <h4 className="fw-bold mb-4">What Sets Us Apart</h4>
            <ul className="list-unstyled mb-0">
              {features.map((item, i) => (
                <li key={i} className="d-flex align-items-start mb-3">
                  <CheckCircleFill className="text-primary me-3 mt-1" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column */}
          <div className="col-lg-6">
            <div className="row g-3">
              {stats.map((stat, i) => (
                <div key={i} className="col-6">
                  <div className="stat-card text-center">
                    <h3 className="fw-bold text-primary mb-1">
                      {stat.value}
                    </h3>
                    <p className="text-muted mb-0">
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
